export var OrganizationSsoProvider;
(function (OrganizationSsoProvider) {
    OrganizationSsoProvider["AZUREAD"] = "azuread";
    OrganizationSsoProvider["OKTA"] = "okta";
    OrganizationSsoProvider["GENERIC_OIDC"] = "oidc";
    OrganizationSsoProvider["ONELOGIN"] = "oneLogin";
    OrganizationSsoProvider["GOOGLE"] = "google";
})(OrganizationSsoProvider || (OrganizationSsoProvider = {}));
export const isOrganizationSsoProvider = (value) => Object.values(OrganizationSsoProvider).includes(value);
//# sourceMappingURL=organizationSso.js.map